module.exports = __webpack_public_path__ + "media/images/icons/news-paper-c2fb164a8d6e33573bb50d43772e46a4.svg";